//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { InvoiceFormat } from './Enums';

export abstract class GenericInvoiceInputItem extends ReportInputItem {
    DueDate: string | null = null;
    InvoiceFormat: InvoiceFormat = InvoiceFormat.Expanded;
    InvoiceDate: string = "1970-01-01T00:00:00";
    FooterNote: string | null = null;
    SendEmail: boolean = false;
    AttemptAutoPay: boolean = false;

    static override readonly ClassName: string = "GenericInvoiceInputItem";
}
